import {useEffect, useRef} from "react";
import {Box, Stack} from "@mui/material";
import LoadingChatUI from "./chat/LoadingChatUI";
import UserChatUI from "./chat/UserChatUI";
import AssistantChatUI from "./chat/AssistantChatUI";
import {IMessage, MessageRoleType} from "../../store/api/aiAssistantApiSlice";

interface ChatBodyUIProps {
  messages: IMessage[];
  isPolling: boolean;
  handleSendMessage: (message: string, messageId?: string) => void;
}

export default function ChatBodyUI({
  messages,
  isPolling,
  handleSendMessage,
}: ChatBodyUIProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      messagesEndRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    });
  }, [messages, isPolling]);

  return (
    <Box
      ref={containerRef}
      sx={{
        overflowY: "auto",
        overflowX: "auto",
        scrollBehavior: "smooth",
        // px: 1,
      }}>
      <Stack spacing={2}>
        {messages.map((message, index) => (
          <div key={message.id ?? index}>
            {message.role === MessageRoleType.USER && (
              <UserChatUI message={message} />
            )}
            {message.role === MessageRoleType.ASSISTANT && (
              <AssistantChatUI
                message={message}
                showActionBar={index === messages.length - 1}
                handleSendMessage={handleSendMessage}
              />
            )}
          </div>
        ))}
        {/* <Box height={8} /> */}
        {isPolling && <LoadingChatUI />}

        {/* ref to scroll towards end */}
        <div ref={messagesEndRef} />
      </Stack>
    </Box>
  );
}
